// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PRODUCT_INDEX_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    PRODUCT_INDEX_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.productIndexSection
      };
    },
    PRODUCT_INDEX_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexSection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
